import { StorageItem } from '../../../../apis/client-axios';
import ButtonAgree from '../../../../components/buttonCustom/ButtonAgree';
import ButtonAgreeWhite from '../../../../components/buttonCustom/ButtonAgreeWhite';
import RowDetail from '../../../../components/InfoRow/NewRowDetail';
import ImageItemReturn from '../../return/component/Image-item';
import { decode as decodeHtml } from 'he';
import { getLinkItemEbayNavigate } from '../../../../util/function-util';

type TProps = {
  itemDetail?: StorageItem;
  src?: string;
  internalSku?: string;
  itemName?: string;
  itemId?: string;
  itemSku?: string;
  price?: number;
  accountEbay?: string;
  showAllButton?: boolean;
  showAllButtonLabel?: string;
  showAllButtonActive?: boolean;
  hideDefaultContent?: boolean;
  onClickShowAll?: () => void;
  children?: any;
};

const ProductInfo = ({
  itemDetail,
  src,
  internalSku,
  itemName,
  itemId,
  itemSku,
  price,
  accountEbay,
  showAllButton,
  showAllButtonLabel = '全ての商品を表示',
  showAllButtonActive = false,
  hideDefaultContent = false,
  onClickShowAll,
  children,
}: TProps) => {
  return (
    <div className="box product-info">
      <div className="title">
        <h3>商品情報</h3>
        {showAllButton && (
          <div className="product-info__title-actions">
            {showAllButtonActive ? (
              <ButtonAgree
                value={showAllButtonLabel}
                onClick={onClickShowAll || (() => {})}
                subClass="product-info__show-all"
              />
            ) : (
              <ButtonAgreeWhite
                value={showAllButtonLabel}
                onClick={onClickShowAll || (() => {})}
                subClass="product-info__show-all"
              />
            )}
          </div>
        )}
      </div>
      {!hideDefaultContent && (
        <div className="box__wrap">
          <div className="product-info__img">
            <ImageItemReturn
              index={0}
              type="PREVIEW"
              url={itemDetail ? itemDetail?.ebayReturns?.ebayItemImage || itemDetail?.preview?.source || '' : src || ''}
              width={118}
            />
          </div>
          <div className="list-info list-info__product">
            <RowDetail label="BayPack管理番号" value={itemDetail ? itemDetail?.internalSku : internalSku} />
            <RowDetail
              label="商品名"
              value={decodeHtml(itemDetail ? itemDetail?.itemName : itemName ? itemName : '')}
              nameRow
              isLink={true}
              href={getLinkItemEbayNavigate(itemDetail ? itemDetail?.ebayReturns?.ebayItemId : itemId)}
              underline={true}
              rows={2}
            />
            <RowDetail label="セラーSKU" value={itemDetail ? itemDetail?.itemSku : itemSku} />
            <RowDetail
              label="申告価格"
              value={
                itemDetail?.itemPrice
                  ? `$${Number(itemDetail?.itemPrice.toFixed(2))}`
                  : price
                    ? `$${Number(price)}`
                    : ''
              }
            />
            <RowDetail
              label="アカウント名"
              value={itemDetail ? itemDetail?.ebayReturns?.accountEbay?.name : accountEbay ? accountEbay : ''}
            />
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default ProductInfo;
